import { Germany } from '@corratech/air-ooka-header/StoreSwitcher/Flags/Germany'
import { UAE } from '@corratech/air-ooka-header/StoreSwitcher/Flags/UAE'
import { useTranslation } from 'next-i18next'
import { useStoreConfig } from '@config/hooks/useStoreConfig'
import { USA } from '@corratech/air-ooka-header/StoreSwitcher/Flags/USA'

type LocalesType =
    | { de: string; en: string }
    | { ar: string; en: string }
    | { en: string }

export type StoreSwitcherConfigType = {
    country: string
    locales: LocalesType
    flag: JSX.Element
    store: string
    url: string
}
export const useStoreSwitcherConfig = (): StoreSwitcherConfigType[] => {
    const { t } = useTranslation('common')
    const config = useStoreConfig()

    return [
        {
            store: 'ooka_de_store',
            locales: { de: t('Deutsch'), en: t('English') },
            flag: <Germany />,
            country: t('DE'),
            url: config.base?.otherWebsiteUrls?.ooka_de as string
        },
        {
            store: 'ooka_uae_store',
            locales: { ar: t('Arabic'), en: t('English') },
            flag: <UAE />,
            country: t('ME'),
            url: config.base?.otherWebsiteUrls?.ooka_ae as string
        },
        {
            store: 'ooka_usa_store',
            locales: { en: t('English') },
            flag: <USA />,
            country: t('USA'),
            url: config.base?.otherWebsiteUrls?.ooka_us as string
        }
    ]
}
